export default "__VITE_ASSET__BQMZ176I__"